'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.run(function (defaultChartOptions, highchartExporter) {
  defaultChartOptions.exporting.buttons.contextButton.menuItems.push({
    textKey: 'ExporterLeGraphique',
    onclick: function onclick() {
      highchartExporter.openExportPopin(this);
    }
  });
});
ngModule.factory("highchartExporter", function ($modal) {
  return {
    openExportPopin: function openExportPopin(chart) {
      $modal.open({
        controller: "highchartExportPopinController",
        template: require("./highchartExportPopin.html"),
        vars: {
          originalChart: chart
        },
        options: {
          width: 1220
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/highcharts/exporter/highcharts-exporter.js
// module id = 2958
// module chunks = 13